export class Offer {
  constructor(public OfferPreview?: OfferPreview) {}
}

export class OfferPreview {
  constructor(
    public title?: string,
    public valueOffer?: string,
    public typeDiscount?: string,
    public valueDiscount?: string,
    public description?: string
  ) {}
}
